import {
  ChargingStatus,
  ChargingStatusStr,
  DeviceType,
} from '@services/constants'
import {
  sumCountByDeviceType,
  useSessionDeviceStatistical,
} from '@services/device'
import { imageUrlPrefix } from '@shared/env'
import { useInnmaxMap } from '@shared/InnmaxMap2/Provider'
import { Button } from '@shared/innmaxUI/Form'
import cx from 'classnames'
import React from 'react'
import styled, { css } from 'styled-components'
import { IParkingLotMarkerProps } from '../../map.types'
import Popup from '../Popup'
import Marker, { IEnhanceMarkerRef } from './Marker'

enum MarkerImageType {
  PNG = '.png',
  SVG = '.svg',
}

function markerIcon(options: {
  unavailableCount: number
  availableCount: number
  inUseCount: number
  imageType: MarkerImageType
}) {
  let status = ChargingStatusStr[ChargingStatus.AVAILABLE]
  if (options.availableCount > 0) {
    status = ChargingStatusStr[ChargingStatus.AVAILABLE]
  } else if (options.inUseCount > 0) {
    status = ChargingStatusStr[ChargingStatus.INUSE]
  } else if (options.unavailableCount > 0) {
    status = ChargingStatusStr[ChargingStatus.UNAVAILABLE]
  }

  return {
    icon: `${imageUrlPrefix}/marker/parkingLot/${status}${options.imageType}`,
    focusIcon: `${imageUrlPrefix}/marker/parkingLot/focus-${status}${options.imageType}`,
  }
}

const ParkingLotMarker = React.memo((props: IParkingLotMarkerProps) => {
  const {
    item,
    focus,
    selected,
    onDelete,
    onDragEnd,
    onLeftClick,
    onEnter,
    devicestatisticalBySessionId,
    ...others
  } = props

  const { focusParkingLot } = useInnmaxMap()

  const markerRef = React.useRef<IEnhanceMarkerRef>(null)
  const [showRightClickMenu, setShowRightClickMenu] = React.useState(false)

  const { getSessionDeepStatistical } = useSessionDeviceStatistical()

  const statistical = getSessionDeepStatistical(
    item,
    devicestatisticalBySessionId
  )

  const icon = markerIcon({
    inUseCount: sumCountByDeviceType(
      statistical,
      'summaryChargingCount',
      DeviceType.CONNECTOR
    ),
    unavailableCount: sumCountByDeviceType(
      statistical,
      'summaryUnavailableCount',
      DeviceType.CONNECTOR
    ),
    availableCount: sumCountByDeviceType(
      statistical,
      'summaryAvailableCount',
      DeviceType.CONNECTOR
    ),
    imageType: MarkerImageType.PNG,
  })

  const className = cx(
    { selected: selected },
    { 'icon-animation': focus },
    'marker-wrapper'
  )

  React.useEffect(() => {
    markerRef.current?.setPosition({
      lat: item?.lat,
      lon: item?.lon,
      x: item?.x,
      y: item?.y,
    })
  }, [item])

  return Marker.Utils.isValidMarkerPosition(item) ? (
    <Marker
      {...others}
      ref={markerRef}
      tooltipContent={<span>{item?.name}</span>}
      onDelete={() => item && onDelete && onDelete(item)}
      onLeftClick={() => {
        item && onLeftClick && onLeftClick(item)
      }}
      onRightClick={() => {
        setShowRightClickMenu(true)
      }}
      defaultPosition={{
        lat: item?.lat,
        lon: item?.lon,
        x: item?.x,
        y: item?.y,
      }}
      onDragEnd={position => {
        onDragEnd &&
          onDragEnd({
            ...item,
            ...position,
          } as any)
      }}>
      <Marker.MarkerIconDiv>
        <div className="relative">
          <img
            css={css`
              padding: 3px;
            `}
            src={icon.icon}
            alt={item.name}
          />
          {focusParkingLot?.id === item?.id && (
            <FocusImg src={icon.focusIcon} alt="focus" />
          )}
        </div>
      </Marker.MarkerIconDiv>

      <Popup
        visible={showRightClickMenu}
        onClose={() => {
          setShowRightClickMenu(false)
        }}>
        <ButtonStyled
          onClick={() => {
            item && onEnter && onEnter(item)
          }}>
          進入站點
        </ButtonStyled>
      </Popup>
    </Marker>
  ) : (
    <div></div>
  )
})

export default ParkingLotMarker

const ButtonStyled = styled(Button)`
  border: 0px !important;
  color: #fff !important;
  background-color: #5c6365;
  width: 150px;
  &:hover,
  &:focus {
    background-color: #0486ff;
  }
  &::after {
  }
`

const FocusImg = styled.img`
  display: block;
  position: absolute;
  top: -110px;
  left: 0%;
  z-index: 1;
`
